import { gql } from '@apollo/client';
import TENANT_TEMPLATE from 'api/fragments/TENANT_TEMPLATE';
const ADD_TENANT_TEMPLATE = gql `
  ${TENANT_TEMPLATE}
  mutation AddTenantTemplate($elementIds: [ID]!, $name: String!) {
    addModelSpecificationTemplate(elementIds: $elementIds, name: $name) {
      modelSpecificationTemplate {
        ...TenantTemplateFragment
      }
    }
  }
`;
export default ADD_TENANT_TEMPLATE;
